const video_play_svg = `<svg width="118" height="118" viewBox="0 0 118 118" fill="none" xmlns="http://www.w3.org/2000/svg">
		<circle cx="59" cy="59" r="58" stroke="currentColor" stroke-width="2" />
		<path class="icon icon-play" d="M83 59L47 79.7846L47 38.2154L83 59Z" fill="currentColor" />
		<g class="icon icon-pause" fill="currentColor">
			<rect x="42.064" y="38.77" width="11.872" height="41.12" />
			<rect x="64.064" y="38.77" width="11.872" height="41.12" />
		</g>
	</svg>
	<span class="label | visually-hidden">Play</span>`;

const video_cc_svg = `<svg width="16px" height="12px" viewBox="0 0 16 12" xmlns="http://www.w3.org/2000/svg">
		<path  d="M 14 0 C 15.105 0 16 0.895 16 2 L 16 10 C 16 11.105 15.105 12 14 12 L 2 12 C 0.895 12 0 11.105 0 10 L 0 2 C 0 0.895 0.895 0 2 0 L 14 0 Z" class="icon-backdrop"></path>
		<g class="icon icon-cc-on">
			<path d="M 2 0 C 0.895 0 0 0.895 0 2 L 0 10 C 0 11.105 0.895 12 2 12 L 14 12 C 15.105 12 16 11.105 16 10 L 16 2 C 16 0.895 15.105 0 14 0 L 2 0 Z M 5.027 4.002 C 4.197 4.002 3.708 4.644 3.708 5.755 L 3.708 6.498 C 3.708 7.605 4.188 8.225 5.027 8.225 C 5.717 8.225 6.165 7.79 6.213 7.175 L 7.36 7.175 L 7.36 7.289 C 7.303 8.436 6.332 9.227 5.018 9.227 C 3.405 9.227 2.5 8.199 2.5 6.498 L 2.5 5.751 C 2.5 4.051 3.414 3 5.018 3 C 6.336 3 7.308 3.813 7.36 5 L 7.36 5.11 L 6.213 5.11 C 6.165 4.472 5.708 4.002 5.027 4.002 L 5.027 4.002 Z M 11.167 4.002 C 10.336 4.002 9.848 4.644 9.848 5.755 L 9.848 6.498 C 9.848 7.605 10.328 8.225 11.166 8.225 C 11.856 8.225 12.305 7.79 12.353 7.175 L 13.5 7.175 L 13.5 7.289 C 13.443 8.436 12.472 9.227 11.158 9.227 C 9.545 9.227 8.64 8.199 8.64 6.498 L 8.64 5.751 C 8.64 4.051 9.554 3 11.158 3 C 12.476 3 13.448 3.813 13.5 5 L 13.5 5.11 L 12.353 5.11 C 12.305 4.472 11.848 4.002 11.166 4.002 L 11.167 4.002 Z"></path>
		</g>
		<g class="icon icon-cc-off">
			<path d="M 3.708 5.755 C 3.708 4.644 4.196 4.002 5.027 4.002 C 5.708 4.002 6.165 4.472 6.213 5.109 L 7.36 5.109 L 7.36 5 C 7.308 3.814 6.336 3 5.018 3 C 3.414 3 2.5 4.05 2.5 5.751 L 2.5 6.498 C 2.5 8.198 3.405 9.228 5.018 9.228 C 6.332 9.228 7.303 8.436 7.36 7.289 L 7.36 7.175 L 6.213 7.175 C 6.165 7.79 5.717 8.225 5.027 8.225 C 4.187 8.225 3.708 7.605 3.708 6.498 L 3.708 5.755 L 3.708 5.755 Z M 9.848 5.755 C 9.848 4.644 10.336 4.002 11.166 4.002 C 11.848 4.002 12.305 4.472 12.353 5.109 L 13.5 5.109 L 13.5 5 C 13.447 3.814 12.476 3 11.158 3 C 9.554 3 8.64 4.05 8.64 5.751 L 8.64 6.498 C 8.64 8.198 9.545 9.228 11.158 9.228 C 12.472 9.228 13.443 8.436 13.5 7.289 L 13.5 7.175 L 12.353 7.175 C 12.305 7.79 11.856 8.225 11.166 8.225 C 10.327 8.225 9.848 7.605 9.848 6.498 L 9.848 5.755 L 9.848 5.755 Z"></path>
			<path d="M 14 1 C 14.552 1 15 1.448 15 2 L 15 10 C 15 10.552 14.552 11 14 11 L 2 11 C 1.448 11 1 10.552 1 10 L 1 2 C 1 1.448 1.448 1 2 1 L 14 1 Z M 2 0 C 0.895 0 0 0.895 0 2 L 0 10 C 0 11.105 0.895 12 2 12 L 14 12 C 15.105 12 16 11.105 16 10 L 16 2 C 16 0.895 15.105 0 14 0 L 2 0 Z"></path>
		</g>
		
	</svg>
	<span class="label | visually-hidden">Show Captions</span>`;

function setVideoBlockCaptionsPosition(tracks) {
	tracks.mode = "hidden";
	// console.log(tracks.cues);
	// console.log(typeof tracks.cues);

	for (const cue in tracks.cues) {
		// console.log(cue);
		// cue.size = 50;
	}
}

function setVideoBlockCaptionsOff(video, button) {
	video.textTracks[0].mode = "hidden";

	video.classList.remove("is-captioned");
	button.classList.remove("is-captioned");

	button.title = button.querySelector(".label").innerText = "Show Captions";
}

function setVideoBlockCaptionsOn(video, button) {
	video.textTracks[0].mode = "showing";

	video.classList.add("is-captioned");
	button.classList.add("is-captioned");

	button.title = button.querySelector(".label").innerText = "Hide Captions";
}

function setVideoBlockPlaybackPause(video, button, container) {
	container.classList.remove("is-playing");
	video.classList.remove("is-playing");
	button.classList.remove("is-playing");

	button.title = button.querySelector(".label").innerText = "Play Video";
}

function setVideoBlockPlaybackPlay(video, button, container) {
	container.classList.add("is-playing");
	video.classList.add("is-playing");
	button.classList.add("is-playing");

	button.title = button.querySelector(".label").innerText = "Pause Video";
}

document.querySelectorAll(".wp-block-video").forEach(function (block) {
	const video = block.querySelector("video");
	const play_button = document.createElement("button");

	video.setAttribute("controlsList", "nodownload");

	if (video.autoplay) {
		return false;
	}

	if (video.textTracks.length > 1) {
		return false;
	} else if (video.textTracks.length === 1) {
		video.removeAttribute("controls");

		setVideoBlockCaptionsPosition(video.textTracks[0]);

		const cc_button = document.createElement("button");
		cc_button.classList.add("video-cc-button", "|", "button", "button-style-icon", "|", "has-color-scheme-dark");
		cc_button.innerHTML = video_cc_svg;
		cc_button.title = cc_button.innerText.trim();

		cc_button.addEventListener("click", function () {
			// console.log(video.textTracks[0]);
			if (video.textTracks[0].mode == "showing") {
				setVideoBlockCaptionsOff(video, cc_button);
			} else {
				setVideoBlockCaptionsOn(video, cc_button);
			}
			// console.log(video.textTracks[0]);
		});

		block.appendChild(cc_button);
	} else {
		video.removeAttribute("controls");
	}

	play_button.classList.add("video-play-button", "|", "button", "button-style-icon", "|", "has-color-scheme-dark");
	play_button.innerHTML = video_play_svg;
	play_button.title = play_button.innerText.trim();

	play_button.addEventListener("click", function () {
		if (video.paused) {
			video.play();
		} else {
			video.pause();
		}
	});
	play_button.removeAttribute("hidden");

	video.addEventListener("play", function (event) {
		setVideoBlockPlaybackPlay(video, play_button, block);
	});
	video.addEventListener("pause", function (event) {
		setVideoBlockPlaybackPause(video, play_button, block);
	});

	block.appendChild(play_button);
	block.classList.add("has-custom-controls");
});
